import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { createSelectors } from '@/utils/createSelectors'

import { createLocationSlice } from './slices/locationSlice'
import { createPromotionSlice } from './slices/promotionSlice'
import { createReservationSlice } from './slices/reservationSlice'
import { createRoomConfigurationSlice } from './slices/roomConfigurationSlice'
import { createRoomSelectionSlice } from './slices/roomSelectionSlice'
import { createTravelPeriodSlice } from './slices/travelPeriodSlice'
import { CartStoreSlices } from './slices/types'

const useCartStoreBase = create<CartStoreSlices, [['zustand/devtools', never]]>(
	devtools(
		(...a) => ({
			...createLocationSlice(...a),
			...createRoomConfigurationSlice(...a),
			...createTravelPeriodSlice(...a),
			...createRoomSelectionSlice(...a),
			...createPromotionSlice(...a),
			...createReservationSlice(...a),
		}),
		{ name: 'name', store: 'CartStore' }
	)
)

export const useCartStore = createSelectors(useCartStoreBase)
